__turbopack_context__.v({
  "actions": "ZTqQeG_actions",
  "closeButton": "ZTqQeG_closeButton",
  "content": "ZTqQeG_content",
  "dialog": "ZTqQeG_dialog",
  "header": "ZTqQeG_header",
  "loginButton": "ZTqQeG_loginButton",
  "text": "ZTqQeG_text",
  "title": "ZTqQeG_title",
});
